module.exports = __webpack_public_path__ + "img/mini-008.58dcef79.jpg";